/* eslint-disable no-unused-vars */
/* eslint-disable function-paren-newline */
/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
import {
  cartesian,
  convertStatusNumberToText,
  convertToCurrentGMT,
  exportToCsv,
  getFirstStringAndUppercase,
  groupBy,
  handleDataOrder,
  handleDataOrderByPercentage,
  normalizeName,
  sortArrayBaseOnAnotherArray,
  sumUpdate,
} from '_utils/function'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useHistory } from 'react-router'
import { useToasts } from 'react-toast-notifications'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

import eventApi from '_api/event'
import {
  callNewListOrder,
  clearAllEvents,
  clearMyEvents,
  updateStatusEvent,
  updateEventCostInStore,
} from '_redux/modules/event'
import {
  BUYER_ORDER_CANCELED,
  BUYER_REFUNDED,
  EVENT_IS_REOPEN,
  HOST_ORDER_CANCELED,
  NOT_PAYABLE,
  NOT_PAYNOW,
  PAYABLE,
  PAYNOW,
  PURCHASE_TYPE_ITEM,
  PURCHASE_TYPE_CASE,
} from '_utils/constant'
import { setCreateEventData } from '_utils/localData'

import useQuery from '_hooks/useQuery'
import { useModal } from '_hooks/useModal'
import { useDispatch } from 'react-redux'
import { clearDataPurchaseDetail, clearMyOrder } from '_redux/modules/order'
import ActionsBox from './components/ActionsBox'
import EventCostModal from './components/EventCostModal'

const ModalExport = ({ eventAndOrderById, isOpen, toggle, isNoSplitCase }) => {
  // const { eventAndOrderById } = useSelector((state) => state.event)
  const {
    title,
    description,
    closingTime,
    pickupTime,
    createdUserName,
    createdUserPhone,
    orders = [],
    adminCost,
    discount,
    deliveryCost,
    isPercentage = false,
    productIdList,
    orderDiscountEnabled,
    orderDiscount
  } = eventAndOrderById || {}
  const {
    listOrder,
    totalAllOrder,
    adminCostAllOrder,
    paymentCollected,
    totalPriceAfterDiscount,
  } = isPercentage ? handleDataOrderByPercentage(
    orders,
    adminCost,
    discount,
    deliveryCost,
    [...productIdList],
    orderDiscountEnabled,
    orderDiscount
  ) : handleDataOrder(
    orders,
    adminCost,
    discount,
    deliveryCost,
    [...productIdList],
    orderDiscountEnabled,
    orderDiscount
  )

  const ordersActive = orders.filter(
    (order) =>
      order.buyerStatus !== BUYER_ORDER_CANCELED &&
      order.buyerStatus !== BUYER_REFUNDED &&
      order.status !== HOST_ORDER_CANCELED
  )
  const cleanCaseCartonText = (name) => {
    if (isNoSplitCase) {
      return name.replace(/\(CASE\/CARTON\)\s*/gi, '').trim()
    }
    return name
  }
  const firstName = createdUserName ? createdUserName.split(' ').slice(0, 1) : ''
  const lastName = createdUserName ? createdUserName.split(' ').slice(1).join(' ') : ''

  const generalInfo = [
    ['Title', title],
    ['Description', description],
    ['Closing Date', convertToCurrentGMT(closingTime).trim().split(' ')[0]],
    ['Closing Time', convertToCurrentGMT(closingTime).trim().split(' ')[1]],
    ['Pick-up Date', convertToCurrentGMT(pickupTime).trim().split(' ')[0]],
    ['Pick-up Time', convertToCurrentGMT(pickupTime).trim().split(' ')[1]],
    ['Organiser First Name', firstName],
    ['Organiser Last Name', lastName],
    ['Organiser Number', createdUserPhone],
    [''],
  ]

  const hasDiscount = Boolean(totalPriceAfterDiscount && Number(totalPriceAfterDiscount) > 0)
  const effectiveTotalPurchase = hasDiscount
    ? Number(totalAllOrder) - Number(totalPriceAfterDiscount)
    : Number(totalAllOrder)

  const total = [
    ['Total Purchase', `$${effectiveTotalPurchase.toFixed(2)}`],
    ['Admin Fee', `$${adminCostAllOrder}`],
    ['Payment Confirmed', `$${paymentCollected}`],
    [''],
  ]

  const totalOrderArr = ordersActive.reduce((acc, curr) => {
    const found = acc.find((item) => item.pid === curr.pid);
    if (found) {
      found.count += curr.pQuantity;
    } else {
      acc.push({ ...curr, count: curr.pQuantity });
    }
    return acc;
  }, []);
  const totalOrderArrIndividual = ordersActive
  .filter((order) => order.pPurchaseType === PURCHASE_TYPE_ITEM)
  .reduce((acc, curr) => {
    const found = acc.find((item) => item.pid === curr.pid);
    if (found) {
      found.count += curr.pQuantity;
    } else {
      acc.push({ ...curr, count: curr.pQuantity });
    }
    return acc;
  }, []);

  const totalOrderArr2 = ordersActive.reduce((acc, curr) => {
    // find by pid && pPurchaseType
    const found = acc.find(
      (item) => item.pid === curr.pid && item.pPurchaseType === curr.pPurchaseType
    );
    if (found) {
      found.count += curr.pQuantity;
    } else {
      acc.push({ ...curr, count: curr.pQuantity });
    }
    return acc;
  }, []);
  const rowsOfTotalOrder = new Array(totalOrderArr.length)

  const export1 = () => {
    const sanitizeCSV = (val) => {
      if (val == null) return ''
      const s = String(val).replace(/\r?\n/g, ' ')
      const escaped = s.replace(/"/g, '""')
      return /[",\r\n]/.test(s) ? `"${escaped}"` : escaped
    }
    const rowsOfProduct = new Array(ordersActive.length) || []
    for (let index = 0; index < ordersActive.length; index++) {
      const product = ordersActive[index]
      const num = ordersActive.filter((o) => o.ref === product.ref).length

      const {
        eOrderNo,
        ref,
        uName,
        uPhone,
        consignee,
        pQuantity,
        pName,
        pPrice,
        buyerStatus,
        status: productStatus,
        pSubItems,
        comment,
        combinedPaymentRef,
        bookingAddress,
      } = product

      const productFromSource = eventAndOrderById?.products?.find((p) => p.id === product.pid)
      const basePrice =
        product.pPriceNoSubItems != null
          ? product.pPriceNoSubItems
          : product.pPurchaseType === PURCHASE_TYPE_ITEM
          ? (productFromSource?.splitCasePurchase?.costPerItem ?? pPrice)
          : (productFromSource?.price ?? pPrice)

      const newRef = `${getFirstStringAndUppercase(title)}-${ref.slice(0, 6).toUpperCase()}`
      const { deliveryPerOrder } = listOrder.find((x) => x.ref === ref)
      const sharedDiscount = Number(discount * ((pPrice * pQuantity) / totalAllOrder))
      const sharedDeliveryCost = Number(deliveryPerOrder / num)
      const adminFee = Number(adminCost / num)
      const amount = pPrice * pQuantity - sharedDiscount + sharedDeliveryCost + adminFee
      const payTogether = combinedPaymentRef ? 'Yes' : 'No'
      let pNameAndSub = pName

      if (product.pPurchaseType === PURCHASE_TYPE_ITEM) {
        pNameAndSub = `(INDIVIDUAL) ${pName}`
      }

      if (product.pPurchaseType === PURCHASE_TYPE_CASE) {
        if (product.pSplitCasePurchase) {
          pNameAndSub = `(CASE/CARTON) ${pName}`
        } else {
          pNameAndSub = `${pName}`
        }
      }

      if (Array.isArray(pSubItems) && pSubItems.length) {
        // build subitems once, escape internal double quotes, use " | " as separator
        pNameAndSub += ' ('
        const sanitizedSub = pSubItems.map((subItem) => {
          const name = String(subItem.name).replace(/\r?\n/g, ' ')
          const escapedName = name.replace(/"/g, '""')
          const subGroup = productFromSource?.subItems?.find((g) => g.type === subItem.type)
          const isCombo =
            (subGroup?.selectionMode === 'multiple' && !subGroup?.trackInventory) ||
            subItem?.selectionMode === 'multiple'
          const isQuantities =
            subGroup?.trackInventory === true ||
            subGroup?.selectionMode === 'quantities' ||
            subItem?.trackInventory === true ||
            subItem?.selectionMode === 'quantities'
          const shouldShowQty = isCombo || isQuantities
          const qtyText = shouldShowQty ? ` x${subItem?.qty ?? 1}` : ''
          return `${escapedName}${qtyText}: +$${subItem.price}`
        })
        pNameAndSub += sanitizedSub.join(' | ')
        pNameAndSub += ')'
      }

      pNameAndSub = sanitizeCSV(cleanCaseCartonText(pNameAndSub))

      const buyerFirstName = uName ? uName.split(' ').slice(0, 1) : ''
      const buyerLastName = uName ? uName.split(' ').slice(1).join(' ') : ''
      rowsOfProduct[index] = [
        eOrderNo,
        newRef,
        buyerFirstName,
        buyerLastName,
        uPhone,
        consignee || uName || '',
        pQuantity,
        pNameAndSub,
        basePrice,
        sharedDiscount.toFixed(2),
        sharedDeliveryCost.toFixed(2),
        adminFee.toFixed(2),
        Number(amount).toFixed(2),
        convertStatusNumberToText(buyerStatus), // BUYER
        convertStatusNumberToText(productStatus), // HOST
        payTogether,
        comment ? String(comment).replace(/\r?\n/g, ' ') : '',
        bookingAddress ? String(bookingAddress).replace(/\r?\n/g, ' ') : '',
        product.deliveryDate || '',
      ]
    }

    for (let index = 0; index < totalOrderArr.length; index++) {
      const totalOrder = totalOrderArr[index]

      const { pName, count } = totalOrder

      rowsOfTotalOrder[index] = [pName, count]
    }
    const totalOrderNoSplitCase = ordersActive.reduce((s, order) => s + +order.pQuantity, 0);

    const totalCaseCount = ordersActive
    .filter((order) => order.pPurchaseType === PURCHASE_TYPE_CASE && order.pSplitCasePurchase)
    .reduce((s, order) => s + Number(order.pQuantity || 0), 0)
    const rowsOfTotalCaseOrder = [
      [isNoSplitCase ? 'Total orders' : 'Total Case/Carton orders', isNoSplitCase ? totalOrderNoSplitCase : totalCaseCount]
    ]

    const rows = [
      ...generalInfo,
      [
        'Order No',
        'Ref',
        'First Name',
        'Last Name',
        'Contact',
        'Consignee Name',
        'Quantity',
        'Item',
        'Price',
        'Shared discount',
        'Shared delivery cost',
        'Admin fee',
        'Amount',
        'Payment',
        'Status',
        'Pay together',
        'Comment',
        'Booking Address',
        'Delivery Date',
      ],
      ...rowsOfProduct,
      [''],
      ...total,
      ['Total orders'],
      ...rowsOfTotalOrder,
      ...rowsOfTotalCaseOrder,
    ]

    const fileName = normalizeName(title)
    exportToCsv(`${fileName}.csv`, rows)
  }

  const export2 = () => {
    const { products } = eventAndOrderById

    const rowsOfContact = new Array(0)
    let colsOfProduct = []

    for (let i = 0; i < totalOrderArr.length; i++) {
      const order = totalOrderArr[i]
      const productFromSource = products.find((x) => x.id === order.pid)
      const actualProductName = productFromSource ? productFromSource.name : order.pName
      const subitems = productFromSource?.subItems || []
      subitems.sort((a, b) => (a.type > b.type ? 1 : b.type > a.type ? -1 : 0))

      const hasQuantities = subitems.some(
        (g) => g.trackInventory === true || g.selectionMode === 'quantities'
      )
      const hasCombo = subitems.some(
        (g) => g.selectionMode === 'multiple' && !g.trackInventory
      )

      if (hasQuantities) {
        const quantitiesGroups = subitems.filter(
          (g) => g.trackInventory === true || g.selectionMode === 'quantities'
        )
        const optCols = []
        quantitiesGroups.forEach((group) => {
          (group.list || []).forEach((option) => {
            optCols.push({
              pid: order.pid,
              name: `(Case/Carton)${actualProductName} (${option.name})`,
              price: Number(option.price || 0),
              subItemName: option.name,
              mode: 'quantities',
            })
          })
        })
        colsOfProduct = [...colsOfProduct, ...optCols]
      } else if (hasCombo) {
        const comboGroups = subitems.filter(
          (g) => g.selectionMode === 'multiple' && !g.trackInventory
        )
        const comboCols = [
          {
            pid: order.pid,
            name: `(Case/Carton)${actualProductName}`,
            price: 0,
            isBaseComboCol: true,
            mode: 'combo',
          },
        ]
        comboGroups.forEach((group) => {
          (group.list || []).forEach((option) => {
            comboCols.push({
              pid: order.pid,
              name: `(Case/Carton)${actualProductName} (${option.name})`,
              price: Number(option.price || 0),
              subItemName: option.name,
              isOptionComboCol: true,
              mode: 'combo',
            })
          })
        })
        colsOfProduct = [...colsOfProduct, ...comboCols]
      } else if (subitems.length > 0) {
        const listTempProName = []
        const listTempProPrice = []
        for (let j = 0; j < subitems.length; j++) {
          const subitem = subitems[j]
          const optionsTempName = []
          const optionsTempPrice = []
          const { list, required } = subitem
          if (required === 0) {
            optionsTempName.push('')
            optionsTempPrice.push(0)
          }
          for (let k = 0; k < list.length; k++) {
            const option = list[k]
            optionsTempName.push(option.name)
            optionsTempPrice.push(option.price)
          }
          listTempProName.push(optionsTempName)
          listTempProPrice.push(optionsTempPrice)
        }

        let cartesianProductPrice = []
        if (listTempProPrice.length) {
          cartesianProductPrice = cartesian(listTempProPrice.map((item) => item))
        }

        if (!listTempProName.length) listTempProName.push([order.pName])
        if (!listTempProPrice.length) listTempProPrice.push([order.pPrice])

        const cartesianProductName = cartesian(listTempProName.map((item) => item))
        const _products = []

        for (let l = 0; l < cartesianProductName.length; l++) {
          const variantName = cartesianProductName[l].filter(Boolean).join(', ')
          let productPrice = 0
          if (cartesianProductPrice.length) {
            productPrice = cartesianProductPrice[l].reduce((a, b) => a + b, 0)
          }
          _products.push({
            pid: order.pid,
            name: variantName
              ? `(Case/Carton)${actualProductName} (${variantName})`
              : `(Case/Carton)${actualProductName}`,
            price: productPrice,
            variantName,
            mode: 'choose_one',
          })
        }
        colsOfProduct = [...colsOfProduct, ..._products]
      } else {
        colsOfProduct.push({
          pid: order.pid,
          name: `(Case/Carton)${actualProductName}`,
          price: 0,
          mode: 'normal',
        })
      }

      totalOrderArr[i] = { ...order, subItems: subitems }
    }

    for (const item of totalOrderArrIndividual) {
      const itemProductFromSource = products.find((x) => x.id === item.pid)
      const itemActualProductName = itemProductFromSource ? itemProductFromSource.name : item.pName
      colsOfProduct.push({
        pid: item.pid,
        name: `(Individual)${itemActualProductName}`,
        price: 0, // no-subitem
        mode: 'individual',
      })
    }
    const _totalOrderArr = sortArrayBaseOnAnotherArray(totalOrderArr, [...productIdList])

    const _sortColsOfProduct = sortArrayBaseOnAnotherArray(colsOfProduct, [...productIdList])

    for (let i = 0; i < products.length; i++) {
      const productTemp = products[i]
      for (let j = 0; j < _sortColsOfProduct.length; j++) {
        const product = _sortColsOfProduct[j]
        // handle price carton/case and individual
        if (
          product.pid === productTemp.id &&
          product.name.startsWith('(Case/Carton)')
        ) {
          if (!product.isOptionComboCol) {
            _sortColsOfProduct[j] = { ...product, price: product.price + productTemp.price }
          }
        }
        if (
          product.pid === productTemp.id &&
          product.name.startsWith('(Individual)')
        ) {
          _sortColsOfProduct[j] = { ...product, price: productTemp.splitCasePurchase?.costPerItem }
        }
      }
    }

    const groupByOrderWithBuyerID = groupBy(ordersActive, 'uid')
    const listOfBuyerName = Object.keys(groupByOrderWithBuyerID)

    for (let i = 0; i < _sortColsOfProduct.length; i++) {
      const col = _sortColsOfProduct[i]
      const product = products.find((p) => p.id === col.pid)
      // remove (Case/Carton) prefix from name if splitCasePurchase is empty
      if (product && (!product.splitCasePurchase || Object.keys(product.splitCasePurchase).length === 0)) {
        _sortColsOfProduct[i].name = col.name.replace(/^\(Case\/Carton\)\s*/i, '')
      }
    }
    const colProductName = _sortColsOfProduct.map((p) => p.name)
    const colProductNameAndId = _sortColsOfProduct.map((p) => `${p.name} ${p.pid}`)
    const colProductPrice = _sortColsOfProduct.map((p) => `$${p.price}`)

    if (Array.isArray(listOfBuyerName)) {
      for (let i = 0; i < listOfBuyerName.length; i++) {
        const colOrderContact = []
        const buyerID = listOfBuyerName[i]
        const { uPhone: buyerPhone } = groupByOrderWithBuyerID[buyerID][0]
        const buyerOrders = groupByOrderWithBuyerID[buyerID] || []

        for (let k = 0; k < _sortColsOfProduct.length; k++) {
          const col = _sortColsOfProduct[k]
          let _quantity = 0

          for (let j = 0; j < buyerOrders.length; j++) {
            const objOrder = buyerOrders[j]
            if (objOrder.pid === col.pid) {
              if (col.mode === 'individual') {
                if (objOrder.pPurchaseType === PURCHASE_TYPE_ITEM) {
                  _quantity += Number(objOrder.pQuantity || 0)
                }
              } else if (objOrder.pPurchaseType !== PURCHASE_TYPE_ITEM) {
                if (col.mode === 'quantities' || col.isOptionComboCol) {
                  // Option của Choose Quantities hoặc Build a Combo: lấy số lượng từ subItem.qty
                  const matchedSub = (objOrder.pSubItems || []).find((s) => s.name === col.subItemName)
                  if (matchedSub) {
                    _quantity += Number(matchedSub.qty ?? matchedSub.quantity ?? 1)
                  }
                } else if (col.isBaseComboCol) {
                  // Cột sản phẩm cha của Build a Combo: lấy số lượng cha
                  _quantity += Number(objOrder.pQuantity || 0)
                } else if (col.mode === 'choose_one') {
                  // Choose One: so khớp tổ hợp variantName
                  const orderVariantName = (objOrder.pSubItems || [])
                    .slice()
                    .sort((a, b) => (a.type > b.type ? 1 : b.type > a.type ? -1 : 0))
                    .map((s) => s.name)
                    .filter(Boolean)
                    .join(', ')
                  if ((col.variantName || '') === orderVariantName) {
                    _quantity += Number(objOrder.pQuantity || 0)
                  }
                } else {
                  // Sản phẩm thường không có sub-item
                  _quantity += Number(objOrder.pQuantity || 0)
                }
              }
            }
          }
          colOrderContact.push(_quantity)
        }

        const buyerFirstName = groupByOrderWithBuyerID[buyerID][0].uName
          ? groupByOrderWithBuyerID[buyerID][0].uName.split(' ').slice(0, 1)
          : ''
        const buyerLastName = groupByOrderWithBuyerID[buyerID][0].uName
          ? groupByOrderWithBuyerID[buyerID][0].uName.split(' ').slice(1).join(' ')
          : ''

        const comments = groupByOrderWithBuyerID[buyerID].map((order) => order.comment)
        const commentCombined = comments.filter((comment) => comment !== null).join(', ').replace(/\r?\n/g, ' ')

        // Get unique booking addresses
        const bookingAddresses = groupByOrderWithBuyerID[buyerID]
          .map((order) => order.bookingAddress)
          .filter((address) => address !== null && address !== undefined)
          .map((address) => address.replace(/,\s*,/g, ',').replace(/,\s*$/, '').trim()) // Normalize: remove redundant commas
        const uniqueBookingAddresses = [...new Set(bookingAddresses)]
        const bookingAddressCombined = uniqueBookingAddresses.join(' | ').replace(/\r?\n/g, ' ')

        const consignees = groupByOrderWithBuyerID[buyerID]
          .map((order) => order.consignee || order.uName)
          .filter((consigneeName) => consigneeName !== null && consigneeName !== undefined && consigneeName !== '')
        const uniqueConsignees = [...new Set(consignees)]
        const consigneeCombined = uniqueConsignees.join(' | ').replace(/\r?\n/g, ' ')

        rowsOfContact.push([
          '',
          buyerFirstName,
          buyerLastName,
          buyerPhone,
          consigneeCombined,
          commentCombined,
          bookingAddressCombined,
          ...colOrderContact,
        ])
      }
    }

    for (let index = 0; index < _totalOrderArr.length; index++) {
      const totalOrder = _totalOrderArr[index]

      const { pName, count } = totalOrder

      rowsOfTotalOrder[index] = [pName, count]
    }
    const totalOrderNoSplitCase = ordersActive.reduce((s, order) => s + +order.pQuantity, 0);

    const totalCaseCount = ordersActive
    .filter((order) => order.pPurchaseType === PURCHASE_TYPE_CASE && order.pSplitCasePurchase)
    .reduce((s, order) => s + Number(order.pQuantity || 0), 0)
    const rowsOfTotalCaseOrder = [
      [isNoSplitCase ? 'Total orders' : 'Total Case/Carton orders', isNoSplitCase ? totalOrderNoSplitCase : totalCaseCount]
    ]

    if (isNoSplitCase) {
      for (let i = 0; i < colProductName.length; i++) {
        colProductName[i] = cleanCaseCartonText(colProductName[i])
        colProductNameAndId[i] = cleanCaseCartonText(colProductNameAndId[i])
      }
    }

    const rows = [
      ...generalInfo,
      ['', '', '', '', '', '', '', ...colProductPrice],
      ['', 'First Name', 'Last Name', 'Contact', 'Consignee Name', 'Comment', 'Booking Address', ...colProductName],
      ...rowsOfContact,
      [''],
      ...total,
      ['Total orders'],
      ...rowsOfTotalOrder,
      ...rowsOfTotalCaseOrder,
    ]

    const fileName = normalizeName(title)
    exportToCsv(`${fileName}.csv`, rows)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className='p-0'>
        <div className='c-form'>
          <div className='form-group container text-center'>
            <h2 className='c-txt-gray'>Select the file format you want to export</h2>
            <div className='row'>
              <div className='col-6'>
                <button onClick={export1} className='btn btn--org btn--org02'>
                  Format 1
                </button>
              </div>
              <div className='col-6'>
                <button onClick={export2} className='btn btn--org btn--org02'>
                  Format 2
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

const Navbar = ({
  eventId,
  handelBroadcast,
  status,
  setTimeRender,
  payable,
  paynow,
  eventAndOrderById,
  products,
}) => {
  const {
    eventCost
  } = eventAndOrderById || {}
  const history = useHistory()
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const query = useQuery()
  const isByAdmin = query.get('isByAdmin') === 'true'
  const [modal, setModal] = useState(false)
  const [message, setMessage] = useState('')
  const [openModalExport, setOpenModalExport] = useState(false)

  const eventCostModal = useModal()

  const handleSaveEventCost = async (val) => {
    try {
      dispatch(clearDataPurchaseDetail())
      dispatch(clearMyOrder())
      await eventApi.updateEventCost(eventId, { eventCost: val })
      dispatch(updateEventCostInStore(eventId, val))
      dispatch(callNewListOrder())
      if (setTimeRender) {
        setTimeRender((prevState) => prevState + 1)
      }
      addToast('Event cost updated', { appearance: 'success', autoDismiss: true })
    } catch (error) {
      const { msgResp } = error || {}
      addToast(msgResp || 'Failed to update event cost', { appearance: 'error', autoDismiss: true })
    }
  }

  const toggle = () => setModal(!modal)

  const toggleModalExport = () => setOpenModalExport(!openModalExport)

  const onEditPostClicked = () => {
    if (paynow === NOT_PAYNOW && payable === PAYABLE) {
      alert('Not allow to edit event')
    } else {
      const { orders, ...eventData } = eventAndOrderById || {}
      const clonedProducts = (eventData.products || []).map((product) => ({
        ...product,
        pid: product.id,
      }))

      const { closingTime, pickupTime } = eventData
      const closingTimeCurrentGMT = convertToCurrentGMT(closingTime)
      const pickupTimeCurrentGMT = convertToCurrentGMT(pickupTime)

      const payload = {
        ...eventData,
        products: clonedProducts,
        closingTime: closingTimeCurrentGMT,
        pickupTime: pickupTimeCurrentGMT,
      }

      setCreateEventData(payload)
      history.push(`/event/hosting?id=${eventId}`)
    }
  }

  const onChangeMessage = (e) => {
    setMessage(e.target.value)
  }

  const onCloseOrderClicked = async () => {
    try {
      const r = confirm('Are you sure?')
      if (r === true) {
        await eventApi.updateEventStatus(eventId, { status: 0 })
        dispatch(callNewListOrder())
        dispatch(updateStatusEvent())
        dispatch(clearAllEvents())
        dispatch(clearMyEvents())
        setTimeRender((prevState) => prevState + 1)
      }
    } catch (error) {
      const { msgResp } = error
      addToast(msgResp, { appearance: 'error', autoDismiss: true })
    }
  }

  const onOpenOrderClicked = async () => {
    try {
      if (paynow === PAYNOW || (paynow === NOT_PAYNOW && payable === NOT_PAYABLE)) {
        const r = confirm('Are you sure?')
        if (r === true) {
          await eventApi.updateEventStatus(eventId, { status: 1 })
          dispatch(updateStatusEvent())
          dispatch(callNewListOrder())
          dispatch(clearAllEvents())
          dispatch(clearMyEvents())
          setTimeRender((prevState) => prevState + 1)
        }
      } else {
        alert('You can not re-open order for this event')
      }
    } catch (error) {
      const { msgResp } = error
      addToast(msgResp, { appearance: 'error', autoDismiss: true })
    }
  }

  const onCreateNotification = () => {
    handelBroadcast(message)
    toggle()
  }

  const onExportOrder = () => {
    setOpenModalExport(true)
  }

  const disabledStyleActions = {
    background: 'rgb(241, 241, 241)',
    pointerEvents: 'none',
  }

  const isnosplitcase = products.every(
    (p) => !p.splitCasePurchase || Object.keys(p.splitCasePurchase).length === 0
  )
// console.log(eventAndOrderById);
  return (
    <>
      <ActionsBox
        onEditEvent={onEditPostClicked}
        onBroadcast={toggle}
        eventCost={eventCost}
        onAddEventCost={eventCostModal.openModal}
        onCloseOrder={status === EVENT_IS_REOPEN ? onOpenOrderClicked : onCloseOrderClicked}
        onExportOrders={onExportOrder}
        isClosed={status === EVENT_IS_REOPEN}
        isByAdmin={isByAdmin}
      />
      <EventCostModal
        modal={eventCostModal}
        onSave={handleSaveEventCost}
        initialCost={eventCost}
      />
      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader className='modal-header-created' style={{ margin: '0 auto' }}>
          <span className='c-txt-gra'>Message to Broadcast?</span>
        </ModalHeader>
        <ModalBody>
          <div className='c-form'>
            <div className='form-group'>
              <input
                type='text'
                value={message}
                className='form-control form-control--radius'
                onChange={onChangeMessage}
              ></input>
            </div>
          </div>
        </ModalBody>
        <ModalFooter style={{ justifyContent: 'space-between', flexDirection: 'row' }}>
          <div className='col-6 px-0 m-0' style={{ flexBasis: '48%' }}>
            <button className='btn btn--solid btn--solid04' onClick={toggle}>
              CANCEL
            </button>
          </div>
          <div className='col-6 px-0 m-0' style={{ flexBasis: '48%' }}>
            <button className='btn btn--org btn--org02' onClick={onCreateNotification}>
              OK
            </button>
          </div>
        </ModalFooter>
      </Modal>
      {eventAndOrderById && (
        <ModalExport
          eventAndOrderById={eventAndOrderById}
          eventId={eventId}
          isOpen={openModalExport}
          toggle={toggleModalExport}
          isNoSplitCase={isnosplitcase}
        />
      )}
    </>
  )
}

export default Navbar

Navbar.propTypes = {
  eventId: PropTypes.string,
  handelBroadcast: PropTypes.func,
  status: PropTypes.number,
  setStatusEvent: PropTypes.func,
  payable: PropTypes.number,
  paynow: PropTypes.number,
  isBuyerPaid: PropTypes.bool,
}
